// extracted by mini-css-extract-plugin
module.exports = {"formTitleContainer":"Location_formTitleContainer__3N9AI","formItemContainer":"Location_formItemContainer__11HDk"};